import { ActionIcon } from "@mantine/core";
import { useState } from "react";

import { Icon } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";

type Props = {
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  disabled?: boolean;
};

export const SearchBar = ({
  placeholder = "Rechercher...",
  value = "",
  onChange,
  onClear,
  disabled = false,
}: Props) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  const handleClear = () => {
    setLocalValue("");
    onChange("");
    onClear?.();
  };

  return (
    <Group gap="xs" wrap="nowrap">
      <TextInput
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
        disabled={disabled}
        leftSection={<Icon name="search" size={16} />}
        rightSection={
          localValue ? (
            <ActionIcon variant="transparent" size="sm" onClick={handleClear} disabled={disabled}>
              <Icon name="x" size={14} />
            </ActionIcon>
          ) : null
        }
        style={{ flex: 1 }}
      />
    </Group>
  );
};
